export default __webpack_public_path__ + "static/media/CattleCaseStudy.3a711196.png";